export default __webpack_public_path__ + "static/modal-do-light-64dcc882a16127968aca9678a1884c54.png";